let BACKEND_SERVER = null;
let TRIMMING_SERVER = null;
if (process.env.REACT_APP_BACKEND_SERVER) {
  BACKEND_SERVER = process.env.REACT_APP_BACKEND_SERVER;
} else {
  // BACKEND_SERVER = "http://127.0.0.1:8000/api/";
  // TRIMMING_SERVER = "http://127.0.0.1:8000/api/trimming/";
  // BACKEND_SERVER = "https://tachi-ai-dev1apix.itconnectus.com/api/";
  // TRIMMING_SERVER = "https://tachi-ai-dev1apix.itconnectus.com/api/trimming/";
  BACKEND_SERVER = "https://tachi-apix.itconnectus.com/api/";
  TRIMMING_SERVER = "https://tachi-apix.itconnectus.com/api/trimming/";
}

const config = {
  basename: "",
  defaultPath: "/dashboard",
  fontFamily: "Work Sans, sans-serif",
  borderRadius: 3,
  API_SERVER: BACKEND_SERVER,
  TRIMMING_SERVER: TRIMMING_SERVER,
  ENCRYPT_KEY: "encrypt_item_key",
  TITLE_TXT: "Tachi Ai",
  organization_id: 1,
  OTP_VALIDITY: 120
};

export default config;
